up.compiler('[course-authorization]', (element, { updatable }) => {

  const course = element.closest('.course')
  course.classList.toggle('-updatable', updatable)

})
